(function () {
  var PAGE_SIZE = 4; // cards visible at once on desktop

  document.querySelectorAll('.lp-reviews__layout').forEach(function (section) {
    var filters       = section.querySelectorAll('.lp-reviews__filter');
    var allCards      = Array.from(section.querySelectorAll('.lp-reviews__card'));
    var dotsContainer = section.querySelector('.lp-reviews__dots');
    var cardsWrap     = section.querySelector('.lp-reviews__cards');
    var prevBtn       = section.querySelector('.lp-reviews__nav-prev');
    var nextBtn       = section.querySelector('.lp-reviews__nav-next');
    var nav           = section.querySelector('.lp-reviews__nav');

    if (!cardsWrap) return;

    var currentPage = 0;
    var dots = [];

    function isDesktop() {
      return window.innerWidth >= 769;
    }

    function getVisibleCards() {
      return allCards.filter(function (c) { return !c.hidden; });
    }

    // ── Dots ──────────────────────────────────────────────────────────────────
    // Desktop: 1 dot per page of PAGE_SIZE cards
    // Mobile:  1 dot per individual card

    function buildDots(count) {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('span');
        dot.className = 'lp-reviews__dot';
        dotsContainer.appendChild(dot);
      }
      dots = Array.from(dotsContainer.querySelectorAll('.lp-reviews__dot'));
    }

    function updateDots(activeIndex) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    function dotCount(visibleCount) {
      return isDesktop() ? Math.ceil(visibleCount / PAGE_SIZE) : visibleCount;
    }

    // ── Desktop slider ─────────────────────────────────────────────────────────

    function getCardStep() {
      var containerWidth = cardsWrap.offsetWidth;
      return (containerWidth - (PAGE_SIZE - 1) * 20) / PAGE_SIZE + 20;
    }

    function syncNav(page, totalPages) {
      if (nav) nav.style.display = totalPages > 1 ? '' : 'none';
      if (prevBtn) prevBtn.disabled = page === 0;
      if (nextBtn) nextBtn.disabled = page >= totalPages - 1;
    }

    function goToPage(page) {
      var visible = getVisibleCards();
      var totalPages = Math.ceil(visible.length / PAGE_SIZE);
      currentPage = Math.min(Math.max(0, page), totalPages - 1);
      cardsWrap.style.transform = 'translateX(-' + (currentPage * PAGE_SIZE * getCardStep()) + 'px)';
      updateDots(currentPage);
      syncNav(currentPage, totalPages);
    }

    // ── Mobile carousel ────────────────────────────────────────────────────────

    function getCardStepMobile() {
      var first = cardsWrap.querySelector('.lp-reviews__card:not([hidden])');
      return first ? first.offsetWidth + 10 : 1;
    }

    cardsWrap.addEventListener('scroll', function () {
      if (isDesktop()) return;
      var index = Math.round(cardsWrap.scrollLeft / getCardStepMobile());
      updateDots(index);
    }, { passive: true });

    // ── Prev / Next ───────────────────────────────────────────────────────────

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (isDesktop()) {
          goToPage(currentPage - 1);
        } else {
          cardsWrap.scrollBy({ left: -getCardStepMobile(), behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (isDesktop()) {
          goToPage(currentPage + 1);
        } else {
          cardsWrap.scrollBy({ left: getCardStepMobile(), behavior: 'smooth' });
        }
      });
    }

    // ── Filter tabs ───────────────────────────────────────────────────────────

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var category = btn.dataset.category;

        filters.forEach(function (f) {
          f.classList.remove('is-active');
          f.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        allCards.forEach(function (card) {
          card.hidden = category !== 'all' && card.dataset.category !== category;
        });

        currentPage = 0;
        cardsWrap.style.transition = 'none';
        cardsWrap.style.transform = 'translateX(0)';
        cardsWrap.scrollLeft = 0;
        requestAnimationFrame(function () { cardsWrap.style.transition = ''; });

        var visible = getVisibleCards();
        buildDots(dotCount(visible.length));
        updateDots(0);
        if (isDesktop()) syncNav(0, Math.ceil(visible.length / PAGE_SIZE));
      });
    });

    // ── Init ──────────────────────────────────────────────────────────────────

    var visible = getVisibleCards();
    buildDots(dotCount(visible.length));
    updateDots(0);
    if (isDesktop()) syncNav(0, Math.ceil(visible.length / PAGE_SIZE));
  });
})();
